import { useTranslation } from "react-i18next";
import { Label } from "@/components/ui/label";
import { Select } from "@/components/ui/select";
import { cn } from "@jbnl/shared-ui";
import type { Inschrijfperiode } from "./venster";

interface Props {
  id: string;
  periodes: Inschrijfperiode[];
  gekozen: string | undefined;
  onKies: (inschrijfperiodeId: string) => void;
  className?: string;
}

/**
 * Which window this screen is answering. A shut one is offered too: no read is ever gated, and
 * the form it draws goes read-only rather than disappearing (ADR-0031).
 */
export function InschrijfperiodeKiezer({
  id,
  periodes,
  gekozen,
  onKies,
  className,
}: Props) {
  const { t } = useTranslation("inschrijving");

  return (
    <div className={cn("grid max-w-sm gap-2", className)}>
      <Label htmlFor={id}>{t("kiezer.label")}</Label>
      <Select
        id={id}
        value={gekozen ?? ""}
        onChange={(event) => onKies(event.target.value)}
      >
        {periodes.map((periode) => (
          <option key={periode.id} value={periode.id}>
            {periode.isOpen
              ? periode.name
              : t("kiezer.gesloten", { naam: periode.name })}
          </option>
        ))}
      </Select>
    </div>
  );
}
